export default function (value, tracked, precision) {
  let timeTracked = tracked;
  let overallTracked = value;
  let round = 0;

  if (typeof precision !== 'undefined') {
    round = precision;
  }

  if (typeof tracked === 'undefined') {
    overallTracked = value.overall;
    timeTracked = value.tracked;
  }

  if (timeTracked === 0) {
    return '—';
  }

  return ((overallTracked / timeTracked) * 100).toFixed(round) + '%';
}
